/* Keep in-page collection navigation working in storefront previews. */
document.addEventListener('click', function (event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  var link = event.target.closest('a[href]');
  if (!link || link.target === '_blank') return;
  var url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
  if (url.hash !== '#first-drop' && url.hash !== '#community') return;
  var target = document.getElementById(url.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  target.focus({preventScroll: true});
  try { window.history.replaceState(null, '', url.hash); } catch (error) { /* Sandboxed previews can restrict history updates. */ }
});
